"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _LeftSidebarLayout = require("./LeftSidebarLayout.style");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * 左側欄layout
 */

const LeftSidebarLayout = _ref => {
  let {
    header,
    sidebar,
    children,
    version = "localhost"
  } = _ref;
  const [isShow, setState] = (0, _react.useState)(false);
  const toggleSidebar = () => {
    setState(!isShow);
  };
  return /*#__PURE__*/_react.default.createElement(_LeftSidebarLayout.UiLeftSidebarLayout, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "header"
  }, isShow && /*#__PURE__*/_react.default.createElement("i", {
    className: "material-icons",
    onClick: () => toggleSidebar()
  }, "menu"), header), /*#__PURE__*/_react.default.createElement("div", {
    className: "container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)("sidebar", {
      noActive: isShow
    })
  }, sidebar, /*#__PURE__*/_react.default.createElement("div", {
    className: "version"
  }, version), /*#__PURE__*/_react.default.createElement("div", {
    className: "action"
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "material-icons",
    onClick: () => toggleSidebar()
  }, "navigate_before"))), /*#__PURE__*/_react.default.createElement("div", {
    className: "content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "scroll"
  }, children))));
};
var _default = exports.default = LeftSidebarLayout;
LeftSidebarLayout.propTypes = {
  header: _propTypes.default.element,
  sidebar: _propTypes.default.element,
  children: _propTypes.default.node,
  version: _propTypes.default.string
};